import React from 'react';
import { DateRange } from 'react-day-picker';
import DateRangePicker from 'src/components/common/calendar/DateRangePicker';

interface DateRangePickerModalProps {
  visible: boolean;
  title?: string;
  from: Date;
  to: Date;
  onChange: (range: DateRange) => void;
  onCancel: () => void;
  onConfirm: (range: DateRange) => void | Promise<void>;
}

const DateRangePickerModal: React.FC<DateRangePickerModalProps> = ({
  visible,
  title = '📅 조회 기간 선택',
  from,
  to,
  onChange,
  onCancel,
  onConfirm
}) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-3 max-w-lg w-auto mx-4">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-base font-semibold">{title}</h2>
          <button
            onClick={onCancel}
            className="text-gray-500 hover:text-gray-700 text-lg"
          >
            X
          </button>
        </div>
        <DateRangePicker
          from={from}
          to={to}
          onChange={onChange}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      </div>
    </div>
  );
};

export default DateRangePickerModal;
